import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';


const SearchTextField = ({ label, value, title, onChange, adornment }) => {
  return (
    // <div className="p-2">
      <TextField
        fullWidth
        label={label}
        id={label.replace(/\s+/g, '_').toLowerCase()} // Optional: Generate an id from the label
        value={value}
        title={title}
        onChange={onChange}
        InputProps={{
          endAdornment: adornment ? (
            <InputAdornment position="end">
              {adornment}
            </InputAdornment>
          ) : '',
        }}
      />
    // </div>
  );
};

export default SearchTextField;

// // Usage example
// const ExampleUsage = () => {
//   const [srcinddata, setSrcinddata] = React.useState('');

//   return (
    // <SearchTextField
    //   label="PO Number"
    //   value={srcinddata}
    //   title="Enter PO Number"
    //   onChange={(e) => setSrcinddata(e.target.value)}
    //   adornment={
    //     <IconButton title="Search PO">
    //       <SearchIcon />
    //     </IconButton>
    //   }
    // />
//   );
// };

// export default ExampleUsage;
